import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'

/**
 * Custom hook to access authentication context
 *
 * @returns {Object} Auth context with user, loading, error, signIn, signOut, and other auth methods
 */
export function useAuth() {
  return useContext(AuthContext)
}
